module.exports = __webpack_public_path__ + "img/old-logo-dark.a8d758f6.png";